import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';

export const PaymentProviders = styled.div`
  margin-bottom: ${layout.measurements.spacing100};

  img {
    max-height: 24px;
    margin: ${layout.measurements.spacing050};
  }
`;
export const CheckIcon = styled(CheckCircleIcon)`
  margin-right: ${layout.measurements.spacing050};
`;

type PaymentOptionProps = {
  active: Boolean;
};

export const PaymentOption = styled.li<PaymentOptionProps>(
  props => css`
    display: flex;
    align-items: center;
    margin: ${layout.measurements.spacing025} 0;
    color: ${props.theme.text.secondary};

    ${CheckIcon} {
      color: ${props.theme.colors.positive500};
    }

    ${!props.active &&
      css`
        color: ${props.theme.text.quaternary};
        text-decoration: line-through;

        ${CheckIcon} {
          color: ${props.theme.colors.base300};
        }
      `}
  `
);

export const PaymentOptionList = styled.ul`
  list-style: none;
`;
